/**
 * media.js --- Media content for each article
 *
 * This component consists of the individual pieces of
 * media for each article in a CSS grid, as well as the
 * pop-up video viewer for the video media type
 */

import React from "react"
import MediaPopUp from "./popup"

import * as MediaItems from "./items"

import Style from "./media.module.scss"

/**
 * Media (default): Component for differentiating between different
 * media grid formats based on the article slug.
 *
 * TODO 6: These custom media boards should all be in a dump
 * folder somewhere else. Once an article is created, a component is
 * automatically created here (including MediaPopUp) for its media board.
 * I then create a custom file such as the ones below
 */

const Media = props => {
  if (props.slug === "moments-monoliths") {
    return (
      <>
        <MediaPopUp color={props.color} />
        <div className={Style.gridContainer}>
          <div
            style={{
              position: "absolute",
              left: "3vw",
              display: "grid",
              gridTemplateColumns: "30vw 30vw 30vw",
              gridGap: "2%",
            }}
          >
            <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[0]}
              top={"9vmax"}
            />
            <div />
            <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[2]}
              top={"9vmax"}
            />
          </div>
          <div
            style={{
              position: "absolute",
              left: "34.5vw",
              display: "grid",
              gridTemplateColumns: "30vw",
              height: "35.5vw",
            }}
          >
            <MediaItems.BandCampPlayerLarge
              color={props.color}
              media={props.media[1]}
            />
          </div>
        </div>
      </>
    )
  } else if (props.slug === "reflections-on-building-a-personal-language") {
    return (
      <>
        <MediaPopUp color={props.color} />
        <div className={Style.gridContainer}>
          <div
            style={{
              position: "absolute",
              left: "2vw",
              display: "grid",
              gridTemplateColumns: "30vw 30vw 30vw",
              gridGap: "2%",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "30vw 30vw",
                gridTemplateRows: "1fr 1fr",
                gridGap: "4.5%",
              }}
            >
              <MediaItems.MediaThumbnail
                color={props.color}
                media={props.media[0]}
              />
              <MediaItems.MediaThumbnail
                color={props.color}
                media={props.media[1]}
              />
              <MediaItems.MediaThumbnail
                color={props.color}
                media={props.media[2]}
              />
              <MediaItems.MediaThumbnail
                color={props.color}
                media={props.media[3]}
              />
            </div>
            <div />
            <MediaItems.BandCampPlayerLarge
              color={props.color}
              media={props.media[4]}
            />
          </div>
        </div>
      </>
    )
  } else if (props.slug === "topographies-of-interaction") {
    return (
      <>
        {/*Wrapper for hiding media on iPad setting*/}
        <div className={Style.iPadHidingWrapper}>
          <div className={Style.gridContainer}>
            <div
              style={{
                position: "absolute",
                paddingLeft: "17%",
                width: "35vw",
                height: "auto",
              }}
            >
              <MediaItems.Image media={props.media[0]} />
            </div>
            <div
              style={{
                position: "absolute",
                paddingLeft: "55%",
                top: "1vw",
                width: "31.5vw",
                height: "auto",
              }}
            >
              <MediaItems.BandCampSmall
                color={props.color}
                media={props.media[1]}
              />
            </div>
            <div
              style={{
                position: "absolute",
                paddingLeft: "55%",
                top: "13vw",
                width: "31.5vw",
                height: "auto",
              }}
            >
              <MediaItems.BandCampSmall
                color={props.color}
                media={props.media[2]}
              />
            </div>
            <div
              style={{
                position: "absolute",
                paddingLeft: "55%",
                top: "25vw",
                width: "31.5vw",
                height: "auto",
              }}
            >
              <MediaItems.BandCampSmall
                color={props.color}
                media={props.media[3]}
              />
            </div>
          </div>
        </div>
      </>
    )
  } else if (props.slug === "echoes-mirrors-roses") {
    return (
      <>
        <MediaPopUp color={props.color} />
        <div className={Style.gridContainer}>
          <div
            style={{
              position: "absolute",
              left: "3vw",
              display: "grid",
              gridTemplateColumns: "30vw 30vw 50vw",
              gridGap: "2%",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "30vw",
                gridTemplateRows: "26.5vw",
                gridGap: "4.5%",
              }}
            >
              <MediaItems.MediaThumbnail
                color={props.color}
                media={props.media[2]}
                top={"6vw"}
              />
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateRows: "17.5vw 17.5vw",
                gridGap: "4.5%",
              }}
            >
              <MediaItems.MediaThumbnail
                color={props.color}
                media={props.media[0]}
              />
              <MediaItems.MediaThumbnail
                color={props.color}
                media={props.media[1]}
              />
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "30vw",
                gridTemplateRows: "20.5vw",
                gridGap: "4.5%",
              }}
            >
              <MediaItems.MediaThumbnail
                color={props.color}
                media={props.media[3]}
                top={"9vw"}
              />
            </div>
          </div>
        </div>
      </>
    )
  } else if (props.slug === "wordlike-noiselike-pitchlike") {
    return (
      <>
        <MediaPopUp color={props.color} />
        <div className={Style.gridContainer}>
          <div
            style={{
              position: "absolute",
              left: "3vw",
              display: "grid",
              gridTemplateColumns: "30vw 30vw 30vw",
              gridGap: "2%",
            }}
          >
            <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[0]}
              top={"9vmax"}
            />
            <div />
            <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[2]}
              top={"9vmax"}
            />
          </div>
          <div
            style={{
              position: "absolute",
              top: "13vw",
              left: "34vw",
              width: "31.5vw",
              height: "auto",
            }}
          >
            <MediaItems.BandCampSmall
              color={props.color}
              media={props.media[1]}
            />
          </div>
        </div>
      </>
    )
  } else if (props.slug === "toward-a-future-practice") {
    return (
      <>
        {/*Wrapper for hiding media on iPad setting*/}
        <MediaPopUp color={props.color} />
        <div className={Style.iPadHidingWrapper}>
          <div className={Style.gridContainer}>
            <div
              style={{
                position: "absolute",
                paddingLeft: "17%",
                width: "35vw",
                height: "auto",
                zIndex: "1",
              }}
            >
              <MediaItems.MediaThumbnail
                media={props.media[3]}
                color={props.color}
                top={"15vw"}
              />
            </div>
            <div
              style={{
                position: "absolute",
                top: "1vw",
                paddingLeft: "17%",
                width: "35vw",
                height: "auto",
              }}
            >
              <MediaItems.SoundCloudSmall
                media={props.media[4]}
                color={props.color}
              />
            </div>
            <div
              style={{
                position: "absolute",
                paddingLeft: "55%",
                top: "1vw",
                width: "31.5vw",
                height: "auto",
              }}
            >
              <MediaItems.BandCampSmall
                color={props.color}
                media={props.media[0]}
              />
            </div>
            <div
              style={{
                position: "absolute",
                paddingLeft: "55%",
                top: "13vw",
                width: "31.5vw",
                height: "auto",
              }}
            >
              <MediaItems.BandCampSmall
                color={props.color}
                media={props.media[1]}
              />
            </div>
            <div
              style={{
                position: "absolute",
                paddingLeft: "55%",
                top: "25vw",
                width: "31.5vw",
                height: "auto",
              }}
            >
              <MediaItems.BandCampSmall
                color={props.color}
                media={props.media[2]}
              />
            </div>
          </div>
        </div>
      </>
    )
  } else if (props.slug === "future-visions") {
    return (
      <>
        <MediaPopUp color={props.color} />
        <div className={Style.gridContainer}>
          <div
            style={{
              position: "absolute",
              left: "7vw",
              display: "grid",
              gridTemplateColumns: "30vw 20vw 30vw",
              gridGap: "2%",
            }}
          >
            <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[1]}
              top={"9vw"}
            />
            <div />
            <MediaItems.SoundCloudMedium
              color={props.color}
              media={props.media[0]}
              top={"9vw"}
            />
          </div>
        </div>
      </>
    )
  } else if (props.slug === "boccaccio-responsori") {
    return (
      <>
        <MediaPopUp color={props.color} />
        <div className={Style.gridContainer}>
          <div
            style={{
              position: "absolute",
              left: "7vw",
              display: "grid",
              gridTemplateColumns: "30vw 20vw 30vw",
              gridGap: "2%",
            }}
          >
            <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[0]}
              top={"9vmax"}
            />
            <div />
            <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[1]}
              top={"9vmax"}
            />
          </div>
        </div>
      </>
    )
  } else if (props.slug === "toward-greater-intentionality") {
    return (
      <>
        <MediaPopUp color={props.color} />
        <div className={Style.gridContainer}>
          <div
            style={{
              position: "absolute",
              left: "3.5vw",
              display: "grid",
              gridTemplateColumns: "30vw 30vw 30vw",
              gridGap: "2%",
            }}
          >
            <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[0]}
              top={"1vmax"}
            />
            <div />
            <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[1]}
              top={"1vmax"}
            />
            <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[3]}
              top={"1vmax"}
            />
            <div />
            <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[4]}
              top={"1vmax"}
            />
          </div>
          <div
            style={{
              position: "absolute",
              left: "35vw",
              width: "30vw",
              top: "15vw",
            }}
          >
            <MediaItems.SoundCloudSmall
              color={props.color}
              media={props.media[2]}
            />
          </div>
        </div>
      </>
    )
  } else if (props.slug === "listening-towards-openness") {
    return (null)
  } else if (props.slug === "echoes-of-echoes") {
    return (<>
      <MediaPopUp color={props.color} />
      <div className={Style.gridContainer}>
        <div
          style={{
            position: "absolute",
            left: "3.5vw",
            display: "grid",
            gridTemplateColumns: "30vw 30vw 30vw",
            gridGap: "2%",
          }}
        >
          <MediaItems.MediaThumbnail
            color={props.color}
            media={props.media[0]}
            top={"1vmax"}
          />
          <div />
          <MediaItems.MediaThumbnail
            color={props.color}
            media={props.media[2]}
            top={"1vmax"}
          />
          <MediaItems.MediaThumbnail
            color={props.color}
            media={props.media[3]}
            top={"1vmax"}
          />
          <div />
          <MediaItems.MediaThumbnail
            color={props.color}
            media={props.media[4]}
            top={"1vmax"}
          />
        </div>
        <div style={{ position: "absolute", left: "40vw", top: "10vw", width: "20vw", height: "auto" }}>
          <MediaItems.Image media={props.media[1]} top={"3vmax"} />
        </div>
      </div>
    </>)
  } else if (props.slug === "archive-concert-creative-premieres-2018") {
    return (
      <>
        <MediaPopUp color={props.color} />
        <div className={Style.gridContainer}>
          <div
            style={{
              position: "absolute",
              left: "3.5vw",
              display: "grid",
              gridTemplateColumns: "30vw 30vw 30vw",
              gridGap: "2%",
            }}
          >
            <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[0]}
              top={"1vmax"}
            />
            <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[1]}
              top={"1vmax"}
            />
            <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[2]}
              top={"1vmax"}
            />
            <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[3]}
              top={"1vmax"}
            />
            <div />
            <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[4]}
              top={"1vmax"}
            />
          </div>
        </div>
      </>
    )
  } else if (props.slug === "cymbals"){
      return <div />
  } else if (props.slug === "drilling") {
      return (
          <>
        <MediaPopUp color={props.color} />
        <div className={Style.gridContainer}>
        <div
          style={{
            position: "absolute",
            left: "3vw",
            display: "grid",
            gridTemplateColumns: "30vw 30vw 30vw",
            gridGap: "2%",
          }}
        >
          <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[1]}
              top={"1vmax"}
            />
           <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[2]}
              top={"1vmax"}
            />
           <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[3]}
              top={"1vmax"}
            />
        </div>
        <div
          style={{
            position: "absolute",
            left: "2.5vw",
            top: "20vw", 
            display: "grid",
            gridTemplateColumns: "30vw 30vw 30vw",
            gridGap: "2%",
          }}
        >
        <MediaItems.BandCampPlayerLarge
            color={props.color}
            media={props.media[0]}
        />
          <div />
        <MediaItems.BandCampPlayerLarge
            color={props.color}
            media={props.media[4]}
        />        </div>
      </div>
      </>
      )
  } else if (props.slug === "artists-in-residence-2021-22") {
      return (
        <>
        <MediaPopUp color={props.color} />
        <div className={Style.gridContainer}>
        <div
          style={{
            position: "absolute",
            left: "3vw",
            display: "grid",
            gridTemplateColumns: "30vw 30vw 30vw",
            gridGap: "2%",
          }}
        >
          <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[0]}
              top={"1vmax"}
            />
           <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[1]}
              top={"1vmax"}
            />
           <MediaItems.MediaThumbnail
              color={props.color}
              media={props.media[2]}
              top={"1vmax"}
            />
        </div>
        <div
          style={{
            position: "absolute",
            left: "2.5vw",
            top: "20vw", 
            display: "grid",
            gridTemplateColumns: "30vw 30vw 30vw",
            gridGap: "2%",
          }}
        >
          <div />
          <MediaItems.BandCampPlayerLarge
            color={props.color}
            media={props.media[3]}
          />
          <div />
        </div>
      </div>
      </>
      )
  } else if (props.slug === "using-latent-timbral-space-to-communicate-with-the-dead") {
    return (
        <>
        <MediaPopUp color={props.color} />
        <div className={Style.gridContainer}>
            <div style={{ position: "absolute", left: "0vw", top: "-50vw", width: "20vw", height: "auto" }}>
                <MediaItems.Image media={props.media[0]}  />
                <MediaItems.Image media={props.media[1]} />
                <MediaItems.Image media={props.media[2]}  />
                <MediaItems.Image media={props.media[3]} />
                <MediaItems.Image media={props.media[4]} />
                <MediaItems.Image media={props.media[5]}  />
            </div>
            <div style={{ position: "absolute", left: "20vw", top: "-10vw", width: "30vw", height: "auto" }}>
                <MediaItems.Image media={props.media[0]}  />
                <MediaItems.Image media={props.media[1]} />
                <MediaItems.Image media={props.media[2]}  />
                <MediaItems.Image media={props.media[3]} />
                <MediaItems.Image media={props.media[4]} />
                <MediaItems.Image media={props.media[5]}  />
            </div>
            <div style={{ position: "absolute", left: "80vw", top: "-20vw", transform: "rotate(45deg)", width: "20vw", height: "auto" }}>
                <MediaItems.Image media={props.media[0]}  />
                <MediaItems.Image media={props.media[1]} />
                <MediaItems.Image media={props.media[2]}  />
                <MediaItems.Image media={props.media[3]} />
                <MediaItems.Image media={props.media[4]} />
                <MediaItems.Image media={props.media[5]}  />
            </div>
            <div style={{ position: "absolute", left: "60vw", top: "-20vw", transform: "rotate(140deg)", width: "20vw", height: "auto" }}>
                <MediaItems.Image media={props.media[0]}  />
                <MediaItems.Image media={props.media[1]} />
                <MediaItems.Image media={props.media[2]}  />
                <MediaItems.Image media={props.media[3]} />
                <MediaItems.Image media={props.media[4]} />
                <MediaItems.Image media={props.media[5]}  />
            </div>
        </div>
      </>
    )
  } else if (props.slug === "the-scorch-manifesto") {
    return (
      <div />
    )
  } else if (props.slug === "expression-collaboration-and-intuition") {
    return (
      <div />
    )
  }
}

export default Media
